import { useFetchDashboardARPayment } from '@hooks';
// import { mapMUITableColumnsToFilterColumns } from '@utils/tableHelper';
import InfiniteScrollWrapper from '@pages/Dashboard/components/InfiniteScrollWrapper';
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import trans from 'translation';
import { KContainer, KInput } from 'uikit';

import { renderPaymentRow } from '../helper';

// import TextFieldSearch from 'components/TextFieldSearch';

// import { getSearchField } from '../helper';

// type Props = {
//   tabName: string;
// };

const ARPayments = () => {
  // const { tabName } = props;

  const location = useLocation();
  const scrollRef = useRef<HTMLDivElement>();

  // const [searchField, setSearchField] = useState('keyword');

  const [searchValue, setSearchValue] = useState('');

  const {
    dataFlatten: data = [],
    isLoading,
    hasNextPage,
    onEndReached
  } = useFetchDashboardARPayment({
    // source: searchField === 'keyword' ? undefined : searchField,
    keyword: searchValue
  });

  useEffect(() => {
    if (location.state?.scrollToBottom) {
      window.history.replaceState({}, document.title);
      console.log(scrollRef);
      scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.state]);

  const onChangeSearch = useCallback((e: any) => {
    const value = e?.target?.value ?? '';
    setSearchValue(value);
  }, []);

  return (
    <KContainer.View
      marginT={0}
      ref={scrollRef as any}
      dp="flex"
      alignItems="stretch"
      flexG={1}
    >
      <KContainer.View marginB="0.5rem">
        {/* <TextFieldSearch
          columns={getSearchField(tabName)}
          handleSearchValue={setSearchValue}
          handleChangeSearchField={setSearchField}
          mapColumns={mapMUITableColumnsToFilterColumns}
        /> */}

        <KInput.Search
          label={trans('search')}
          value={searchValue}
          onChange={onChangeSearch}
        />
      </KContainer.View>

      <InfiniteScrollWrapper
        name="ARPaymentsNotificationDiv"
        data={data}
        isLoading={isLoading}
        hasNextPage={hasNextPage ?? false}
        onEndReached={onEndReached}
        renderRow={item => renderPaymentRow(item)}
      />
    </KContainer.View>
  );
};

export default memo(ARPayments);
